var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero'),_c('analytics'),_c('video-player2'),_c('tour4'),_c('reports2'),_c('l-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }